import { SENDFACTOR_FETCH_REQUEST, SENDFACTOR_FETCH_SUCCESS, SENDFACTOR_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchCheckoutRequest = () => {
    return {
        type: SENDFACTOR_FETCH_REQUEST
    }
}

const fetchCheckoutSuccess = data => {
    return {
        type: SENDFACTOR_FETCH_SUCCESS,
        payload: data,
    }
}

const fetchCheckoutFailure = error => {
    return {
        type: SENDFACTOR_FETCH_FAILURE,
        payload: error,
    }
}

export const sendFactor = (slug) => {
    return (dispatch) => {
        dispatch(fetchCheckoutRequest());
        const token = localStorage.getItem('token');
        fetch(`${baseUrl}/receipts/sms/${slug}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchCheckoutSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchCheckoutFailure(error.message));
            })
    }
}